/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { IDataProvider } from "./IDataProvider";
import { NordiskFilmDataProvider } from "./NordiskFilm";

export const DataProvider: IDataProvider = new NordiskFilmDataProvider();
